import { Box } from '@zillow/constellation-10';

import { tourCardContainerRecipe } from '../styles';

import type { FC, ReactNode } from 'react';

type TourCardContainerProps = {
  hasBigBottomBorder?: boolean;
  size?: 'sm' | 'md';
  isSelected?: boolean; // adds shadow
  children: ReactNode;
};

const TourCardContainer: FC<TourCardContainerProps> = ({
  hasBigBottomBorder = false,
  size = 'sm',
  isSelected = false,
  children,
}) => <Box css={tourCardContainerRecipe.raw({ size, isSelected, hasBigBottomBorder })}>{children}</Box>;

export type { TourCardContainerProps };
export default TourCardContainer;
